import {
  Observable
} from 'rxjs';
import {
  Subscription
} from 'rxjs/Subscription';
/*import {
  dns
} from './../../../providers/global.config';*/
import {
  Component,
  ViewChild
} from '@angular/core';
import {
  DashbordInfo,
  DateInterval
} from '../model/index';
import {
  NavParams
} from 'ionic-angular/navigation/nav-params';
import {
  FuelingService
} from '../../../providers/fueling.service';
import {
  Chart
} from 'chart.js';
import {
  Events
} from 'ionic-angular/util/events';
import { ToastController } from 'ionic-angular/components/toast/toast-controller';



@Component({
  templateUrl: 'dashbord.html'
})
export class Dashbord {
  @ViewChild('doughnutCanvas') doughnutCanvas;
  idVehicule: number = 0;
  doughnutChart: any;
  dashbordInfo: DashbordInfo = null;
  subscriptionVehicule: Subscription;
  matricule: string = null;
  //dns: string = dns;
  options: any;
  date: DateInterval = new DateInterval();
  startDate1: Date = new Date();
  endDate1: Date = new Date();
  startDate: any;
  endDate: any;
  load: boolean = false;
  costInterview: number = 0;
  costTotal: number = 0;
  groupeName = null;


  constructor(navParams: NavParams, private fuelingService: FuelingService, public events: Events,public toastCtrl:ToastController) {
    this.idVehicule = navParams.data.idDevice.idVehicule;
    this.matricule = navParams.data.matricule;
    this.endDate1.setTime(this.endDate1.getTime());
    this.startDate1 = new Date(this.endDate1.getFullYear(), 0, 1);
    this.startDate = (this.startDate1).toISOString();
    this.endDate = (this.endDate1).toISOString();

  }

  ngOnInit() {
  

  }
  getInfoVehiculeDashbord() {
    this.date.startDate = this.startDate;
    this.date.endDate = this.endDate;
    this.fuelingService.getDashbordInfo(this.idVehicule, this.date).subscribe(response => {
      this.dashbordInfo = response;
      this.load = false;
      this.costInterview = this.dashbordInfo.batteryMaintenance + this.dashbordInfo.tireMaintenance + this.dashbordInfo.reparation;
      this.costTotal = this.dashbordInfo.runningDocument + this.dashbordInfo.fuel + this.dashbordInfo.oilChange + this.costInterview;
      if (this.costTotal > 0)
        this.configHighcharts();
      else {
        let toast = this.toastCtrl.create({
          message: 'Aucune information à afficher',
          duration: 3000,
          position: 'top'
        });
        toast.present();
      }

    });
  }
  closeModal() {
    this.events.publish('Dismiss', null);
  }
  configHighcharts() {
    Chart.defaults.global.tooltips.enabled = true;
    Chart.defaults.global.legend.position = 'bottom';
    

    this.doughnutChart = new Chart(this.doughnutCanvas.nativeElement, {
 
        type: 'pie',
        options: {
          responsive: true,
          maintainAspectRatio: false,        
          },
        data: {
            labels: ["Batterie", "Carburant", "Vidange", "Réparation", "Document Circulation", "Pneu"],
            datasets: [{
                label: '# of Votes',
                data: [this.dashbordInfo.batteryMaintenance, this.dashbordInfo.fuel, this.dashbordInfo.oilChange, this.dashbordInfo.reparation, this.dashbordInfo.runningDocument, this.dashbordInfo.tireMaintenance],
                backgroundColor: [
                    'rgba(255, 99, 132, 0.2)',
                    'rgba(54, 162, 235, 0.2)',
                    'rgba(255, 206, 86, 0.2)',
                    '#f9bbcf',
                    '#95ceff',
                    'rgba(255, 159, 64, 0.2)'
                ],
                hoverBackgroundColor: [
                    "#FF6384",
                    "#36A2EB",
                    "#FFCE56",
                    "#FF6384",
                    "#95ceff",
                    "#FFCE56"
                ]
            }]
        }

    });
  }


}



// WEBPACK FOOTER //
// ./src/pages/gestion-park/dashbord/dashbord.ts